// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AttributionRouteImport } from './routes/attribution'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PersonalStuffRouteImport } from './routes/personal-stuff'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsSlugRouteImport } from './routes/projects/$slug'
import { Route as BlogCategoryCategoryRouteImport } from './routes/blog/category/$category'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AttributionRoute = AttributionRouteImport.update({
            id: '/attribution',path: '/attribution',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PersonalStuffRoute = PersonalStuffRouteImport.update({
            id: '/personal-stuff',path: '/personal-stuff',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => rootRouteImport
          })
const ProjectsSlugRoute = ProjectsSlugRouteImport.update({
            id: '/projects/$slug',path: '/projects/$slug',getParentRoute: () => rootRouteImport
          })
const BlogCategoryCategoryRoute = BlogCategoryCategoryRouteImport.update({
            id: '/blog/category/$category',path: '/blog/category/$category',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AttributionRoute: AttributionRoute,ContactRoute: ContactRoute,PersonalStuffRoute: PersonalStuffRoute,ServicesRoute: ServicesRoute,BlogSlugRoute: BlogSlugRoute,ProjectsSlugRoute: ProjectsSlugRoute,BlogIndexRoute: BlogIndexRoute,ProjectsIndexRoute: ProjectsIndexRoute,BlogCategoryCategoryRoute: BlogCategoryCategoryRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)